import React from 'react';
import {LearnerGroup} from '../../data/models/Groups/LearnerGroup';
import {learnerGroupsText} from './learnerGroupsText';
import LearnersEmpty from '../LearnersTable/LearnersEmpty';
import {getFirstCapitals} from '../../utils/getFirstCapitals';
import styles from './GroupsPicker.module.css';

interface Props {
  groups: LearnerGroup[];
  checked: string[];
  search: string;
  onToggle: (groupId: string) => void;
}

const GroupsPicker = React.memo(
  ({groups, checked, search, onToggle}: Props) => {
    if (!groups.length) {
      return search ? (
        <LearnersEmpty title={learnerGroupsText.cantFindGroups} />
      ) : (
        <LearnersEmpty
          title={learnerGroupsText.emptyGroupsTitle}
          text={learnerGroupsText.emptyGroupsText}
        />
      );
    }

    return (
      <div className={styles.wrapper}>
        <div className={styles.head}>
          <span className={styles.headSpacer} />
          <span className={styles.headCell}>
            {learnerGroupsText.columnName}
          </span>
          <span className={styles.headCell}>
            {learnerGroupsText.columnDescription}
          </span>
          <span className={`${styles.headCell} ${styles.headMembers}`}>
            {learnerGroupsText.columnMembers}
          </span>
        </div>

        <div className={styles.rows}>
          {groups.map(group => {
            const selected = checked.includes(group.id);
            return (
              <div
                key={group.id}
                className={`${styles.row} ${selected ? styles.rowChecked : ''}`}
                role="button"
                tabIndex={0}
                onClick={() => onToggle(group.id)}
                onKeyDown={ev => {
                  if (ev.key === 'Enter' || ev.key === ' ') {
                    ev.preventDefault();
                    onToggle(group.id);
                  }
                }}>
                <span
                  className={`${styles.box} ${
                    selected ? styles.boxChecked : ''
                  }`}
                />
                <div className={styles.identity}>
                  <span className={styles.avatar}>
                    {getFirstCapitals(group.name)}
                  </span>
                  <span className={styles.name}>{group.name}</span>
                </div>
                <span className={styles.description}>
                  {group.description || '-'}
                </span>
                <span className={styles.members}>{group.learnersNumber}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);

export default GroupsPicker;
